import { watch, onUnmounted } from '@vue/composition-api';

const TITLE_DELIMITER = '|';

const titleSuffix = (title => {
  const splited = title.split(TITLE_DELIMITER);
  if (splited.length >= 2) {
    return ` ${TITLE_DELIMITER}${splited[splited.length - 1]}`;
  }
  return '';
})(document.title);

export const useDocumentTitle = (titleFunction: () => string) => {
  const unwatch = watch(
    titleFunction,
    newTitle => {
      document.title = newTitle + titleSuffix;
    },
    { immediate: true },
  );

  onUnmounted(unwatch);
};
